import React, { Component } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected"; 
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { CATEGORY_COLOR_SET } from '../../../../config/ColorSet';
import { CATEGORY_SET } from '../../../../config/CategorySet'

class CategoryMap extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount(){
    let chart = null;
    this.createCategoryMap(chart, this.props.data);
  }

  componentWillUnmount(){
    if(this.chart) this.chart.dispose();
  }
  
  createCategoryMap = (chart, dataSet) => {
    chart = am4core.create(this.categoryMapChart, am4plugins_forceDirected.ForceDirectedTree);
    am4core.useTheme(am4themes_animated);

    let series = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries());

    series.data = dataSet;

    series.data[0]['name'] = "[bold, font-size: 25px]"+series.data[0]['name']+"[/]";
    series.data[0]['children'].forEach((item)=>item['name']="[bold]"+item['name']+"[/]");

    series.dataFields.value ="value";
    series.dataFields.name = "name";
    series.dataFields.children = "children";

    series.data[0].fixed =  true;
    series.data[0].x= am4core.percent(43);
    series.data[0].y= am4core.percent(50);
    series.dataFields.fixed="fixed";
    series.nodes.template.propertyFields.x = "x";
    series.nodes.template.propertyFields.y = "y";
    series.dataFields.color="color";

    // Add labels
    series.nodes.template.label.text = "{name}";
    series.nodes.template.label.fontSize = 13;

    series.nodes.template.label.fill = am4core.color("#000000");
    series.nodes.template.tooltipText = "[bold]{name}[/]"

    series.minRadius = 20;
    series.maxRadius = 50;
    series.links.template.distance = 1.1;

    // chart.chartContainer.width = am4core.percent(80);
    // chart.chartContainer.paddingLeft = "50px";

    let legend = new am4charts.Legend();
    legend.parent = chart.chartContainer;
    legend.background.fillOpacity = 0.05;
    legend.width = 100;
    legend.align = "right";
    // legend.paddingLeft = "70px";
    legend.paddingLeft = "10px";
    legend.itemContainers.template.clickable = false;
    legend.itemContainers.template.focusable = false;
    legend.labels.template.text = "[font-size: 13px]{name}[/]";
    let markerTemplate =  legend.markers.template;
    markerTemplate.width = 13;
    markerTemplate.height = 13;
    CATEGORY_SET.forEach((item)=>{
      legend.data.push({
        "name": item,
        "fill": CATEGORY_COLOR_SET[item]
      })
    })

    this.chart = chart;

  }

  render() {
    return(
      <div id="category-map" ref={ref=>(this.categoryMapChart=ref)} style={{ width: this.props.width, height: this.props.height }}></div>
    )
  }
}

export default CategoryMap;